module.exports = __webpack_public_path__ + "static/img/csjz-details.9a0ae2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/csjz-details.png
// module id = VM4H
// module chunks = 0